module.exports = __webpack_public_path__ + "static/assets/45353905cf166ce2cb04d16a217a8d4e.gif";